import { Sidebar, BpmnCellHelper, Graph, PmfEvents, IEditorUi } from "@edp-pmf/grapheditor";
import { BizActivity, UserActivity } from "@gsp-wf/wf-process-model";
import { mxGeometry, MxGraphNS, mxEvent, mxEventObject, mxResources } from "@edp-pmf/mxgraph-ts";
import { UserActivityCell } from "./wf-cell/UserActivityCell";
import { WfConstants } from "./WfConstants";

export class WfSidebar extends Sidebar {
    bizActivities: BizActivity[] = [];
    /**
     * 添加业务活动面板
     * @param bizActivities 
     */
    addBizActPalette(bizActivities: BizActivity[]): void {
        //如果添加了业务活动面板，需要先移除
        if (this.palettes["bizactivitylib"]) {
            this.container.removeChild(this.palettes["bizactivitylib"][0]);
            this.container.removeChild(this.palettes["bizactivitylib"][1]);
            delete this.palettes["bizactivitylib"];
        }
        this.bizActivities = bizActivities;
        let bizActFactories = new Array<() => HTMLAnchorElement>();
        //添加业务活动
        this.bizActivities && this.bizActivities.forEach((activity: BizActivity) => {
            const style = 'image=' + WfConstants.IMAGE_PATH + '/bizActivity.png;';
            const cell = BpmnCellHelper.generate(UserActivity.Clr_Type_ID, undefined, new mxGeometry(0, 0, this.defaultImageWidth, this.defaultImageHeight), style) as UserActivityCell;
            cell.name = activity.name;
            cell.bizActivity = activity;

            bizActFactories.push(this.createItemFactory([cell], cell.name, this.defaultImageWidth, this.defaultImageHeight));
        });

        if (bizActFactories.length > 0) {
            this.addPaletteFunctions('bizactivitylib',  mxResources.get('bizactivitylib'), true, bizActFactories);
        }
    }
}